import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequestComponent } from './features/requets/request/request.component';

const routes: Routes = [
  {path: '' , component:  RequestComponent , pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes , { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
